import type { Transition, Variants } from 'framer-motion';

import {
  POPOVER_EASE,
  POPOVER_ENTER_DURATION_S,
  POPOVER_ENTER_OPACITY_DURATION_S,
  POPOVER_EXIT_DURATION_S,
  POPOVER_EXIT_SCALE,
  POPOVER_HIDDEN_SCALE,
  POPOVER_MOTION_STATE,
} from './constants';

interface GetPopoverVariantsInput {
  springEnter: boolean;
  symmetricExit: boolean;
}

const SPRING_ENTER_TRANSITION: Transition = {
  type: 'spring',
  stiffness: 380,
  damping: 22,
  mass: 0.6,
};

const TWEEN_ENTER_SCALE_TRANSITION: Transition = {
  duration: POPOVER_ENTER_DURATION_S,
  ease: POPOVER_EASE,
};

const ENTER_OPACITY_TRANSITION: Transition = {
  duration: POPOVER_ENTER_OPACITY_DURATION_S,
  ease: POPOVER_EASE,
};

const EXIT_TRANSITION: Transition = {
  duration: POPOVER_EXIT_DURATION_S,
  ease: POPOVER_EASE,
};

export function getPopoverVariants(input: GetPopoverVariantsInput): Variants {
  const enterScaleTransition = input.springEnter
    ? SPRING_ENTER_TRANSITION
    : TWEEN_ENTER_SCALE_TRANSITION;

  return {
    [POPOVER_MOTION_STATE.Hidden]: {
      opacity: 0,
      scale: POPOVER_HIDDEN_SCALE,
    },
    [POPOVER_MOTION_STATE.Visible]: {
      opacity: 1,
      scale: 1,
      transition: {
        opacity: ENTER_OPACITY_TRANSITION,
        scale: enterScaleTransition,
      },
    },
    [POPOVER_MOTION_STATE.Exit]: {
      opacity: 0,
      scale: input.symmetricExit ? POPOVER_HIDDEN_SCALE : POPOVER_EXIT_SCALE,
      transition: {
        opacity: EXIT_TRANSITION,
        scale: EXIT_TRANSITION,
      },
    },
  };
}
